import axios from 'axios'

async function postSubmit(userResponses, tool) {
	const portalId = '3423792'
	let formId = ''

	switch (tool) {
		case 'aro':
			formId = '90a65a73-0c70-48b2-b703-9613cf6dde1f'
			break
		case 'gasb':
			formId = '47adedad-bbfe-4e06-87d7-a9bef578f3cf'
			break
		case 'sbita':
			formId = 'e94fddbf-0c06-424e-afee-1f84e6a0148b'
			break
		case 'rit':
			formId = 'e831ba1d-5efd-46ee-a2eb-56e0c925251c'
			break
		default:
			break
	}

	const response = await axios
		.post(
			`https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
			userResponses,
			{
				headers: {
					'Content-Type': 'application/json',
				},
			}
		)
		.then((response) => {
			return response.data
		})
		.catch((error) => {
			console.error(error)
		})
	return response
}

export default postSubmit
